/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import { styled } from '@mui/material';
import EntriesFilterRow from 'components/Monitor/ResultsTab/TableFilters/EntriesFilterRow';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { IDecompressedData, IScreeningResultRow } from 'interfaces/IBiteDB';
import { decompressData, formatFriendlyTime } from 'utils/common';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { Link } from 'react-router-dom';

interface DashboardProps {
  screeningResults: IScreeningResultRow[];
}

const CustomSelect = styled(Select)({
  '.MuiSelect-icon': {
    color: 'var(--card-text)'
  },
  'overflow': 'hidden',
  'color': 'var(--Text-Main, var(--text-primary))',
  'textOverflow': 'ellipsis',
  'fontFamily': 'Inter',
  'fontSize': '16px',
  'fontStyle': 'normal',
  'fontWeight': 400,
  'lineHeight': '24px',
  'borderRadius': '8px',
  'border': '1px solid var(--bg-secondary)'
});

const ScreeningHistory: React.FC<DashboardProps> = ({ screeningResults }) => {
  const [ allResults, setAllResults ] = React.useState<IDecompressedData[]>([]);
  const [ fieldTicketMap, setFieldTicketMap ] = React.useState<
    Record<string, string>
  >({});
  const [ fieldDatabaseMap, setFieldDatabaseMap ] = React.useState<
    Record<string, string>
  >({});

  useEffect(() => {
    if (screeningResults && screeningResults.length > 0) {
      const fieldToTicket: Record<string, string> = {};
      const fieldToDatabase: Record<string, string> = {};
      const aggregatedResults: IDecompressedData[] = [];

      screeningResults.forEach((row) => {
        const results = row.screening_result?.results;
        if (Array.isArray(results)) {
          results.forEach((r) => {
            if (r.allResults) {
              const decompressed = decompressData(
                r.allResults,
              ) as IDecompressedData[];
              decompressed.forEach((d) => {
                aggregatedResults.push(d);
                fieldToTicket[d.field] = row.screening_result.ticket_name;
                fieldToDatabase[d.field] = row.database_id;
              });
            }
          });
        }
      });

      setAllResults(aggregatedResults);
      setFieldTicketMap(fieldToTicket);
      setFieldDatabaseMap(fieldToDatabase);
    }
  }, [ screeningResults ]);

  return (
    <>
      <div
        className='api-container'
        style={{ gap: '10px', padding: '15px 0px 15px 0px', width: '100%' }}
      >
        <div className='screening-card'>
          <div className='screening-card-header'>
            <div className='title-group'>
              {/* <span className='warning-icon'>⚠️</span> */}
              <h3>Recent Screening Results</h3>
            </div>
          </div>
          <p className='subtitle'>View your most recent screening results</p>
          <div
            style={{ height: '250px', maxHeight: '250px', overflowY: 'auto' }}
          >
            {allResults && allResults.length > 0 ? (
              allResults.map((item, index) => {
                const ticketName = fieldTicketMap[item.field] ?? item.dataSet;
                const id = fieldDatabaseMap[item.field];

                return (
                  <div key={index} className='hit-item'>
                    <div className='hit-main'>
                      <div className='hit-title'>
                        <strong>{item.field}</strong>
                      </div>
                      <div className='hit-meta'>
                        {ticketName} •{' '}
                        <CalendarMonthOutlinedIcon
                          sx={{ fontSize: 14, color: 'var(--text-primary)' }}
                        />{' '}
                        {formatFriendlyTime(
                          screeningResults?.[0]?.screening_timestamp ??
                            undefined,
                        )}
                      </div>
                    </div>
                    <Link
                      to={{
                        pathname: `/database/${id}`,
                      }}
                    >
                      <div className='arrow'>›</div>
                    </Link>
                  </div>
                );
              })
            ) : (
              <div
                className='entries-frame-body-cont-lenses-col'
                style={{ justifyContent: 'center' }}
              >
                <NotificationsActiveOutlinedIcon sx={{ fontSize: 36 }} />
                <p className='subtitle'>No recent screening results</p>
                <p className='subtitle'>Run a screening to see results here</p>
              </div>
            )}
          </div>
          {/* <div className='team-content-header'>
            <div className='create-new-team-btn' style={{ width: '100%', margin: '0px' }}>
              <div className='create-new-team-btn-text' style={{ color: 'var(--text-primary)' }} >
                View All History
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ScreeningHistory;
